module.exports = __webpack_public_path__ + "img/city_books.2022e555.png";